<template>
  <v-toolbar :clipped-left="$vuetify.breakpoint.mdAndUp"
             app
             fixed
             prominents
             v-if="requiresComponent"
  >
    <v-toolbar-side-icon @click="toggleNavigationDrawer" class="hidden-md-and-up">
    </v-toolbar-side-icon>
    <v-toolbar-side-icon @click="toggleNavigationDrawerMini" class="hidden-sm-and-down">
    </v-toolbar-side-icon>
    <v-btn @click="goBack" icon>
      <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title v-text="title">
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <!--<v-text-field-->
      <!--class="hidden-xs-only"-->
      <!--flat-->
      <!--hide-details-->
      <!--label="Search"-->
      <!--prepend-inner-icon="search"-->
      <!--solo-inverted-->
    <!--&gt;</v-text-field>-->
    <v-spacer></v-spacer>

    <!--<v-btn icon>-->
    <!--<v-icon name="search"></v-icon>-->
    <!--</v-btn>-->
    <v-menu left offset-y>
      <v-btn
        icon
        slot="activator"
      >
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile>
<!--          <v-list-tile-title v-if="isOnline">Status : Online-->
<!--            <span class="status online"></span>-->
<!--          </v-list-tile-title>-->
<!--          <v-list-tile-title v-if="isOffline">Status : Offline-->
<!--            <span class="status offline"></span>-->
<!--          </v-list-tile-title>-->
        </v-list-tile>
        <!--<v-list-tile>-->
          <!--<v-list-tile-title>Account settings</v-list-tile-title>-->
        <!--</v-list-tile>-->
        <!--<v-list-tile>-->
          <!--<v-list-tile-title>Feedback</v-list-tile-title>-->
        <!--</v-list-tile>-->
<!--        <v-list-tile @click="logout">-->
<!--          <v-list-tile-title>Logout</v-list-tile-title>-->
<!--        </v-list-tile>-->
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { mapActions } from 'vuex';
import '../scss/mainToolbar.scss';

export default {
  name: 'MainToolbar',

  computed: {
    title: {
      get() {
        return this.$route.name;
      },
    },
    router: {
      get() {
        return this.$router;
      },
    },
    requiresComponent() {
      if (this.$route.name === 'Login') {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapActions([
      'toggleNavigationDrawer',
      'toggleNavigationDrawerMini',
    ]),
    goBack() {
      // TODO when at the entrypage in the application,
      // currently u go back to the previous page outside of the application
      this.$router.go(-1);
    },
    // logout() {
    //   this.$store.dispatch('logout');
    //   this.$router.push({ name: 'Login' });
    // },
  },
};
</script>
